// extracted by mini-css-extract-plugin
module.exports = {"grid":"contact-module--grid--2rfuX","contact":"contact-module--contact--3yNwE"};